import type { DatasetType } from '@common/contexts/support/domain/enums/datasetType';
import type { ExporterType } from '@common/contexts/support/domain/enums/exporterType';
import { AbortableFetch } from '@frontend/store/fetch';

export class Exporter {
    constructor(
        public readonly datasetType: DatasetType,
        public readonly exporterType: ExporterType
    ) {}

    public async download() {
        const abortableFetch = new AbortableFetch();

        const result = await abortableFetch.fetch(
            `/api/support/processes/${this.datasetType}/export/${this.exporterType}`,
            'GET'
        );

        const url = await this.getBlobUrlFromResult(result);
        const filename = this.getFilenameFromHeaders(result.headers);

        const createTemporaryDownloadButton = this.createTemporaryDownloadButton(url, filename);

        createTemporaryDownloadButton.click();
        createTemporaryDownloadButton.remove();
    }

    private createTemporaryDownloadButton(url: string, filename?: string) {
        const button = document.createElement('a');
        button.href = url;

        if (filename) {
            button.download = filename;
        }

        return button;
    }

    private getFilenameFromHeaders(headers: Headers) {
        const contentDispositionHeader = headers.get('Content-Disposition');
        const matches = contentDispositionHeader?.match(/filename="(.+?)"/);

        return matches?.[1];
    }

    private async getBlobUrlFromResult(result: Response) {
        const blob = await result.blob();

        return window.URL.createObjectURL(blob);
    }
}
